import { ClockCircleOutlined } from '@ant-design/icons'
import { Card, Divider, Table, Tooltip } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import * as R from 'ramda'
import React from 'react'

import { printFlightNumber } from '../../helpers/flights'
import { emptyRow, playerColumns, renderIfEmpty, skipIfEmpty } from '../../shared/columns'

import { Flight } from '../../schemas/Flight'
import { TournamentPlayer } from '../../schemas/Player'

const flightCols: Array<ColumnProps<TournamentPlayer & { isEmpty: boolean }>> = [
  { ...playerColumns.nationality, render: skipIfEmpty(playerColumns.nationality.render) },
  {
    ...playerColumns.fullName,
    render: renderIfEmpty(
      {
        children: <div className="emptyRow" />,
        props: { colSpan: 3 },
      },
      playerColumns.fullName.render,
    ),
  },
  { ...playerColumns.team, render: skipIfEmpty(playerColumns.team.render) },
]

type ViewFlightCardProps = {
  flight: Flight
  flightPlayers: TournamentPlayer[]
  flightSize: number
  startsInMinutes?: number
}

const ViewFlightCard = ({
  flight,
  flightPlayers,
  flightSize,
  startsInMinutes,
}: ViewFlightCardProps) => {
  const dataSource = [
    ...flightPlayers,
    ...R.range(0, flightSize - flightPlayers.length).map((emptyIndex) => emptyRow(emptyIndex)),
  ]

  const emptyRowClassName = (record, index) => (record.isEmpty ? 'emptyRow' : '')

  const startsInMessage = `Starts in ${
    startsInMinutes === 0
      ? 'less than 1 minute'
      : `${startsInMinutes} minute${startsInMinutes !== 1 ? 's' : ''}`
  }`

  const flightStartTime = flight.startTime && (
    <React.Fragment>
      <Tooltip title="Start Time">
        <ClockCircleOutlined />
        &nbsp;
        {flight.startTime}
      </Tooltip>
      {!R.isNil(startsInMinutes) && (
        <React.Fragment>
          <Divider type="vertical" />
          {startsInMessage}
        </React.Fragment>
      )}
    </React.Fragment>
  )

  return (
    <Card
      hoverable
      className="flight-card"
      title={printFlightNumber(flight)}
      extra={flightStartTime}>
      <Table
        className="flight-players"
        rowKey="id"
        showHeader={false}
        pagination={false}
        size="small"
        columns={flightCols}
        dataSource={dataSource}
        rowClassName={emptyRowClassName}
      />
    </Card>
  )
}

export default ViewFlightCard



// WEBPACK FOOTER //
// ./src/components/flights/ViewFlightCard.tsx